import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  currentId = null;

  constructor () {
    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._homeSimpleAgentsStore = this;
    }
  }

  setCurrentId = (currentId) => {
    this.currentId = currentId;
  }
  reset = () => {
    this.setCurrentId(null);
  }
}

const homeSimpleAgentsStore = new Store();
export default homeSimpleAgentsStore;